<template>
  <div>
    <BaseModal
      :config="FmvStatementFootnoteModalLabel"
      @ResetFields="resetFields"
      @SaveChanges="saveChanges"
    >
      <div style="width:100%; max-height:500px;overflow-y:auto; overflow-x:hidden;">
        <form ref="refFmvStatementFootnoteForm" id="FmvStatementFootnoteForm" action>
          <div id="pageErrors" class="alert alert-danger" v-if="pageErrors.length>0">
            <b>Please correct the following error(s):</b>
            <ul>
              <li v-for="error in pageErrors" :key="error">{{ error }}</li>
            </ul>
          </div>
          <div class="form-row">
            <div class="form-group col-md-6">
              <label class="required-label">Tax Period</label>

              <div id="kendo-select">
                <kendo-dropdownlist
                  v-model="FmvStatementFootnoteInfo.TaxPeriod"
                  :data-source="TaxPeriodOptions"
                  :data-text-field="'Option'"
                  :option-label="'Select Tax Period'"
                  :data-value-field="'Option'"
                ></kendo-dropdownlist>
              </div>
            </div>
            <div class="form-group col-md-6">
              <label class="required-label">Page</label>
              <div id="kendo-select">
                <kendo-dropdownlist
                  v-model="FmvStatementFootnoteInfo.Page"
                  :data-source="PageOptions"
                  :data-text-field="'Option'"
                  :option-label="'Select Page'"
                  :data-value-field="'Option'"
                ></kendo-dropdownlist>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-6">
              <label class="required-label" for="TagNumber">Tag Number</label>
              <input
                type="text"
                class="form-control"
                id="TagNumber"
                name="TagNumber"
                placeholder="Tag Number"
                v-model="FmvStatementFootnoteInfo.TagNumber"
              />
            </div>
            <div class="form-group col-md-6">
              <label class="required-label">Tag Location</label>
              <div id="kendo-select">
                <kendo-dropdownlist
                  v-model="FmvStatementFootnoteInfo.TagLocation"
                  :data-source="TagLocationOptions"
                  :data-text-field="'Option'"
                  :option-label="'Select Tag Location'"
                  :data-value-field="'Option'"
                  @change="onChangeTagLocation($event)"
                ></kendo-dropdownlist>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-6">
              <label class="required-label">Footnote ID</label>
              <div id="kendo-select">
                <!-- <kendo-dropdownlist v-model="FmvStatementFootnoteInfo.FootnoteId"
                            :data-source="FootnoteIDOptions"
                            :data-text-field="'Option'"
                            :data-value-field="'value'"
                             @change="onFootnoteIDchange">
                </kendo-dropdownlist>-->
                <kendo-autocomplete
                  id="footNoteId"
                  class="form-control"
                  v-model="FmvStatementFootnoteInfo.FootnoteId"
                  :data-source="FootnoteIDOptions"
                  :data-text-field="'Option'"
                  :data-value-field="'value'"
                  :filter="'contains'"
                  :placeholder="'Search for Footnote ID'"
                  @select="onFootnoteIDchange"
                ></kendo-autocomplete>
              </div>
            </div>
            <div
              class="form-group col-md-6"
              v-if="FmvStatementFootnoteInfo.TagLocation==='Investment'"
            >
              <label class="required-label">Investment</label>
              <div id="kendo-select">
                <!-- <kendo-dropdownlist
                  v-model="FmvStatementFootnoteInfo.InvestmentId"
                  :data-source="InvestmentOptions"
                  :data-text-field="'Option'"
                  :data-value-field="'value'"
                >:option-label="'Select Investment'"</kendo-dropdownlist>-->
                <BaseMultiSelectComboBox
                  id="mltInvestment"
                  :dropdownOptions="InvestmentOptions"
                  :criteriaData="criteriaData"
                ></BaseMultiSelectComboBox>
              </div>
            </div>
            <div class="form-group col-md-6" v-if="FmvStatementFootnoteInfo.TagLocation==='Column'">
              <label class="required-label">Column</label>
              <div id="kendo-select">
                <!-- <kendo-dropdownlist
                  v-model="FmvStatementFootnoteInfo.Column"
                  :data-source="ColumnOptions"
                  :data-text-field="'Option'"
                  :option-label="'Select Column'"
                  :data-value-field="'Option'"
                ></kendo-dropdownlist>-->
                <BaseMultiSelectComboBox
                  id="mltColumn"
                  :dropdownOptions="ColumnOptions"
                  :criteriaData="criteriaData"
                ></BaseMultiSelectComboBox>
              </div>
            </div>
            <div
              class="form-group col-md-6"
              v-if="FmvStatementFootnoteInfo.TagLocation==='Investment Group'"
            >
              <label class="required-label">Investment Group</label>
              <div id="kendo-select">
                <!-- <kendo-dropdownlist
                  v-model="FmvStatementFootnoteInfo.InvestmentGroup"
                  :data-source="InvestmentGroupOptions"
                  :data-text-field="'Option'"
                  :option-label="'Select Investment Group'"
                  :data-value-field="'Option'"
                ></kendo-dropdownlist>-->
                <BaseMultiSelectComboBox
                  id="mltInvestmentGroup"
                  :dropdownOptions="InvestmentGroupOptions"
                  :criteriaData="criteriaData"
                ></BaseMultiSelectComboBox>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-12">
              <textarea
                class="form-control"
                v-model="FmvStatementFootnoteInfo.Footnote"
                placeholder="Footnote"
                style=" height: 100%; width: 100%;"
                disabled
              ></textarea>
            </div>
          </div>
        </form>
      </div>
    </BaseModal>
  </div>
</template>

<script>
import $ from "jquery";
//import { VestingClassData  } from "@/local-data/VestingClassData.js";
import BaseModal from "@/components/base/BaseModal.vue";

import apiUtil from "@/services/apiUtil.js";
import funcUtil from "@/services/funcUtil.js";
import BaseModelInputControl from "@/models/BaseModelInputControl.js";
import BaseModelInvestment from "@/models/BaseModelInvestment.js";
import BaseModelFMVStatementFootnote from "@/models/BaseModelFMVStatementFootnote.js";
import BaseModelFootnote from "@/models/BaseModelFootnote.js";
import { isNullOrUndefined } from "util";

import _ from "lodash";
import { mapGetters, mapActions, mapState } from "vuex";
import BaseMultiSelectComboBox from "@/components/base/BaseMultiSelectComboBox.vue";

export default {
  name: "FmvStatementFootnoteForm",
  props: {
    FmvStatementFootnoteInfo: {},
    FmvStatementFootnoteModalLabel: {}
  },
  mixins: [apiUtil],
  computed: {
    ...mapGetters("getModule", ["withFilter", "getLocalInputControls"]),
    ...mapState("postModule", ["response"])
  },
  data: function() {
    return {
      BaseModelInvestment: BaseModelInvestment,
      BaseModelFMVStatementFootnote: BaseModelFMVStatementFootnote,
      displayErrors: false,
      BaseModelInputControl: BaseModelInputControl,
      dropdowns: {
        TaxPeriod: { model: "", dataSource: [] },
        FMVPage: { model: "", dataSource: [] },
        TagLocation: { model: "", dataSource: [] },
        InvestmentGroup: { model: "", dataSource: [] },
        FMVFootnoteColumn: { model: "", dataSource: [] }
        //Column:{model: "", dataSource: []},
      },
      TaxPeriodOptions: [],
      PageOptions: [],
      TagLocationOptions: [],
      InvestmentOptions: [],
      ColumnOptions: [],
      InvestmentGroupOptions: [],
      FootnoteIDOptions: [],
      pageErrors: [],
      criteriaData: {
        DropDownOptions: [],
        showDropdown: false,
        search: "",
        label: "",
        All: false
      }
    };
  },
  methods: {
    ...mapActions("postModule", ["UpdateItems", "CreateItems"]),

    getInputControls() {
      let self = this;
      let response = self.getLocalInputControls(
        self.BaseModelInputControl.list
      );

      console.log(response);
      Object.keys(self.dropdowns).forEach(key => {
        self.dropdowns[key].dataSource = response[key];
      });
      //this.TaxPeriodOptions=this.dropdowns.TaxPeriod.dataSource;
      if (this.dropdowns.TaxPeriod.dataSource.length) {
        this.dropdowns.TaxPeriod.dataSource = _.orderBy(
          self.dropdowns.TaxPeriod.dataSource,
          ["Option"],
          ["asc"]
        );
        this.dropdowns.TaxPeriod.dataSource.forEach(element => {
          //if (element.Option.trim().endsWith("Q2")   || element.Option.trim().endsWith("Q4") ){
          let obj = {};
          obj.Id = element.Id;
          obj.Option = element.Option;
          this.TaxPeriodOptions.push(obj);
          //}
        });
      }

      this.PageOptions = this.dropdowns.FMVPage.dataSource;
      this.TagLocationOptions = this.dropdowns.TagLocation.dataSource;
      this.InvestmentGroupOptions = this.dropdowns.InvestmentGroup.dataSource;
      this.ColumnOptions = this.dropdowns.FMVFootnoteColumn.dataSource;

      let Investmentitems = this.withFilter(BaseModelInvestment.list);
      Investmentitems.forEach(InvestmentItem => {
        this.InvestmentOptions.push({
          Id: InvestmentItem.Id,
          Option: InvestmentItem.Title,
          value: InvestmentItem.Id
        });
      });
      let FootnoteIDitems = this.withFilter(BaseModelFootnote.list);
      FootnoteIDitems.forEach(FootnoteItem => {
        this.FootnoteIDOptions.push({
          Option: FootnoteItem.FootnoteID,
          value: FootnoteItem.Id
        });
      });
    },
    onFootnoteIDchange: function(ev) {
      const self = this;
      self.FmvStatementFootnoteInfo.FootnoteId = ev.dataItem.value;
      let Footnotelist = self.withFilter(BaseModelFootnote.list);
      var result = _.filter(Footnotelist, function(Footnote) {
        return Footnote.Id == self.FmvStatementFootnoteInfo.FootnoteId;
      });
      if (result) {
        self.FmvStatementFootnoteInfo.Footnote = result[0].Footnote;
      }
    },
    Validate: function() {
      const self = this;
      self.pageErrors = [];
      if (self.FmvStatementFootnoteInfo.TaxPeriod == "") {
        self.pageErrors.push("Tax Period is required.");
      }
      if (self.FmvStatementFootnoteInfo.Page == "") {
        self.pageErrors.push("Page is required.");
      }
      if (self.FmvStatementFootnoteInfo.TagNumber == "") {
        self.pageErrors.push("Tag Number  is required.");
      }
      if (self.FmvStatementFootnoteInfo.TagLocation == "") {
        self.pageErrors.push("Tag Location  is required.");
      }
      if (self.FmvStatementFootnoteInfo.TagLocation != "") {
        if (
          self.FmvStatementFootnoteInfo.TagLocation == "Column" &&
          self.criteriaData.DropDownOptions.length == 0
        ) {
          self.pageErrors.push(
            self.FmvStatementFootnoteInfo.TagLocation + " is required."
          );
        }
        if (
          self.FmvStatementFootnoteInfo.TagLocation == "Investment" &&
          self.criteriaData.DropDownOptions.length == 0
        ) {
          self.pageErrors.push(
            self.FmvStatementFootnoteInfo.TagLocation + " is required."
          );
        }
        if (
          self.FmvStatementFootnoteInfo.TagLocation == "Investment Group" &&
          self.criteriaData.DropDownOptions.length == 0
        ) {
          self.pageErrors.push(
            self.FmvStatementFootnoteInfo.TagLocation + " is required."
          );
        }
      }
      if (self.FmvStatementFootnoteInfo.FootnoteId == "") {
        self.pageErrors.push("Footnote is required.");
      }

      return self.pageErrors.length > 0 ? false : true;
    },

    saveChanges: function() {
      //code for add FmvStatementFootnote
      let self = this;
      this.displayErrors = true;
      if (this.FmvStatementFootnoteModalLabel.modalAddorEdit == "add") {
        if (self.Validate()) {
          // Add Popup
          console.log(JSON.stringify(self.FmvStatementFootnoteInfo));
          if (!isNullOrUndefined(self.FootnoteIDOptions)) {
            self.FmvStatementFootnoteInfo.FootnoteId = self.FootnoteIDOptions.filter(
              x =>
                x.Option == self.FmvStatementFootnoteInfo.FootnoteId.toString()
            )[0].value;
          }

          if (self.FmvStatementFootnoteInfo.TagLocation === "Column") {
            self.FmvStatementFootnoteInfo.Column = self.joinMultiSelectValue(
              self.criteriaData.DropDownOptions
            );
          } else if (
            self.FmvStatementFootnoteInfo.TagLocation === "Investment Group"
          ) {
            self.FmvStatementFootnoteInfo.InvestmentGroup = self.joinMultiSelectValue(
              self.criteriaData.DropDownOptions
            );
          } else if (
            self.FmvStatementFootnoteInfo.TagLocation === "Investment"
          ) {
            self.FmvStatementFootnoteInfo.Investments = self.joinMultiSelectValue(
              self.criteriaData.DropDownOptions
            );
          }

          var addFormValues = self.FmvStatementFootnoteInfo;
          // if (addFormValues.InvestmentId == "") {
          //   delete addFormValues.InvestmentId;
          // }
          if (addFormValues.FootnoteId == "") {
            delete addFormValues.FootnoteId;
          }
          let createItem = {
            list: self.BaseModelFMVStatementFootnote,
            payload: addFormValues
          };
          // let loader = this.$loading.show();
          self._APICrudPopup("APICrudpopup");
          this.CreateItems(createItem)
            .then(res => {
              self.$emit("SaveComplete");
              self._AlertPopup("Data Saved Successfully!", "success");
              self.resetFields();
            })
            .catch(error => {
              self._AlertPopup("Some Error Occurred!", "info");
            })
            .finally(() => {
              //loader.hide();
            });
          $("#BaseModal").modal("toggle");
          this.resetFields();
        } else {
          // $('#pageErrors').focus();
          let basemodal = $("#BaseModal");
          $("input:text:visible:first", basemodal).focus();
        }
      } else {
        // Edit Popup
        if (self.Validate()) {
          console.log(JSON.stringify(self.FmvStatementFootnoteInfo));
          if (!isNullOrUndefined(self.FootnoteIDOptions)) {
            self.FmvStatementFootnoteInfo.FootnoteId = self.FootnoteIDOptions.filter(
              x =>
                x.Option == self.FmvStatementFootnoteInfo.FootnoteId.toString()
            )[0].value;
          }

          if (self.FmvStatementFootnoteInfo.TagLocation === "Column") {
            self.FmvStatementFootnoteInfo.Column = self.joinMultiSelectValue(
              self.criteriaData.DropDownOptions
            );
          } else if (
            self.FmvStatementFootnoteInfo.TagLocation === "Investment Group"
          ) {
            self.FmvStatementFootnoteInfo.InvestmentGroup = self.joinMultiSelectValue(
              self.criteriaData.DropDownOptions
            );
          } else if (
            self.FmvStatementFootnoteInfo.TagLocation === "Investment"
          ) {
            self.FmvStatementFootnoteInfo.Investments = self.joinMultiSelectValue(
              self.criteriaData.DropDownOptions
            );
          }

          let editForm = this.FmvStatementFootnoteInfo;
          console.log(editForm);
          if (editForm.TagLocation == "Investment Group") {
            // editForm.InvestmentId = null;
            editForm.Investments = "";
            editForm.Column = "";
          } else if (editForm.TagLocation == "Column") {
            editForm.Investments = "";
            // editForm.InvestmentId = null;
            editForm.InvestmentGroup = "";
          } else if (editForm.TagLocation == "Investment") {
            editForm.InvestmentGroup = "";
            editForm.Column = "";
          }
          //let loader = this.$loading.show();
          this._APICrudPopup("APICrudpopup");
          let updateItem = {
            list: self.BaseModelFMVStatementFootnote,
            payload: editForm
          };
          this.UpdateItems(updateItem)
            .then(res => {
              //console.log(this.response)
              //loader.hide();
              self.$emit("SaveComplete");
              self._AlertPopup("Data Saved Successfully!", "success");
              self.resetFields();
            })
            .catch(error => {
              self._AlertPopup("Some Error Occurred!", "info");
            })
            .finally(() => {
              //loader.hide();
            });
          $("#BaseModal").modal("toggle");
          this.resetFields();
        } else {
          // $('#pageErrors').focus();
          let basemodal = $("#BaseModal");
          $("input:text:visible:first", basemodal).focus();
        }
        // alert("Data Saved Successfully!");
      }
    },
    resetFields: function() {
      this.pageErrors = [];
    },

    onChangeTagLocation(e) {
      const self = this;
      self.criteriaData.All = false;
      self.criteriaData.showDropdown = false;
      self.criteriaData.DropDownOptions = [];
      self.FmvStatementFootnoteInfo.TagLocation = e.sender.text();
      if (self.FmvStatementFootnoteInfo.TagLocation === "Investment") {
        self.criteriaData.label = "Select Investment";
      } else if (self.FmvStatementFootnoteInfo.TagLocation === "Column") {
        self.criteriaData.label = "Select Column";
      } else if (
        self.FmvStatementFootnoteInfo.TagLocation === "Investment Group"
      ) {
        self.criteriaData.label = "Select Investment Group";
      }
    },

    //MultiSelect Investment, InvestmentGroup and Column
    joinMultiSelectValue(selectedArray) {
      const self = this;
      var selectedOptions = "";
      if (selectedArray.length) {
        selectedArray.forEach((element, index) => {
          if (index == 0) {
            selectedOptions = element.Option;
          } else {
            selectedOptions = selectedOptions + "," + element.Option;
          }
        });
      }
      return selectedOptions;
    },

    assginSelectedTagOptions(tagLocation, selectedTagOptions) {
      const self = this;
      self.criteriaData.DropDownOptions = [];
      self.criteriaData.showDropdown = false;
      self.criteriaData.All = false;

      if (selectedTagOptions != null) {
        if (selectedTagOptions.length) {
          if (selectedTagOptions.indexOf(",") < 0) {
            selectedTagOptions = selectedTagOptions + ",";
          }
          var itemArray = selectedTagOptions.split(",");
          itemArray.forEach(item => {
            if (tagLocation === "Column") {
              self.ColumnOptions.forEach(element => {
                if (element.Option === item) {
                  self.criteriaData.DropDownOptions.push(element);
                }
              });
              if (
                self.criteriaData.DropDownOptions.length ==
                self.ColumnOptions.length
              )
                this.criteriaData.All = true;
              else this.criteriaData.All = false;
            } else if (tagLocation === "Investment Group") {
              self.InvestmentGroupOptions.forEach(element => {
                if (element.Option === item) {
                  self.criteriaData.DropDownOptions.push(element);
                }
              });
              if (
                self.criteriaData.DropDownOptions.length ==
                self.InvestmentGroupOptions.length
              )
                this.criteriaData.All = true;
              else this.criteriaData.All = false;
            } else if (tagLocation === "Investment") {
              self.InvestmentOptions.forEach(element => {
                if (element.Option === item) {
                  self.criteriaData.DropDownOptions.push(element);
                }
              });
              if (
                self.criteriaData.DropDownOptions.length ==
                self.InvestmentOptions.length
              )
                this.criteriaData.All = true;
              else this.criteriaData.All = false;
            }
          });
        }
      }
    }
  },
  mounted() {
    const self = this;

    $("body").click(function(e) {
      if (
        $(e.target).closest(".vue-select-container").length == 0 &&
        $(e.target).closest(".vue-dropdown-panel").length == 0
      ) {
        if (self.criteriaData.DropDownOptions.length == 0) {
          self.criteriaData.DropDownOptions = [];
          self.criteriaData.All = false;
        }
        self.criteriaData.showDropdown = false;
      }
    });

    this.getInputControls();

    // alert(JSON.stringify(this.ProgramInfoFormConfig));
    this.resetFields();
    $("#BaseModal").on("shown.bs.modal", function() {
      $("input:text:visible:first", this).focus();
    });

    //For Displaying List on Focus
    this.ShowAutoCompleteListOnFocus("footNoteId");
  },
  components: {
    BaseModal,
    BaseMultiSelectComboBox
  }
};
</script>


<style scoped>
.k-widget.k-autocomplete.k-header.k-state-default {
  width: 250px;
  background-color: yellow;
}
</style>